import React from 'react'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal';

const ROOT_NODE_ID = 'bingo-root';

class App extends React.Component {
    static propTypes = {
        store: PropTypes.object.isRequired,
        routes: PropTypes.object.isRequired,
    };

    componentWillMount() {
        // let token = window.localStorage.getItem('auth_token');
    }

    componentDidMount() {
        ReactModal.setAppElement(`#${ROOT_NODE_ID}`);
    }

    shouldComponentUpdate() {
        return false
    }

    render() {
        return (
            <Provider store={this.props.store}>
                <div id={ROOT_NODE_ID} style={{ height: '100%' }}>
                    <Router history={browserHistory} children={this.props.routes}/>
                </div>
            </Provider>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js